import { EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_MODEL } from "presentation/model/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: ExchangeRateRefDateMappingProvider,
    useTracked: useExchangeRateRefDateMappingTracked
} = createContainer(() => useState(EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_MODEL), {concurrentMode: true});
export { ExchangeRateRefDateMappingProvider, useExchangeRateRefDateMappingTracked };

